export const SHOW_NAV_MENU = 'SHOW_NAV_MENU';
export function showNavMenu() {
  return (dispatch) => {
    dispatch(addRootClasses('show-nav'));
    dispatch({ type: SHOW_NAV_MENU });
  };
}

export const HIDE_NAV_MENU = 'HIDE_NAV_MENU';
export function hideNavMenu() {
  return (dispatch) => {
    dispatch(removeRootClasses('show-nav'));
    dispatch({ type: HIDE_NAV_MENU });
  };
}

export const ROOT_CLASSES_ADD = 'ROOT_CLASSES_ADD';
export function addRootClasses(classes) {
  return {
    type: ROOT_CLASSES_ADD,
    classes,
  };
}

export const ROOT_CLASSES_REMOVE = 'ROOT_CLASSES_REMOVE';
export function removeRootClasses(classes) {
  return {
    type: ROOT_CLASSES_REMOVE,
    classes,
  };
}

export const UTM_COOKIES_SET = 'UTM_COOKIES_SET';
export function utmCookiesSet() {
  return {
    type: UTM_COOKIES_SET,
  };
}
